<template lang="pug">
#modal-enviar-geometria-diagnostico
    el-dialog(
        :title='$t("mensagens.menuSig.realizarDiagnosticoGeometria")',
        :visible.sync='show',
        :before-close='fechar',
        width='800px',
        append-to-body,
        destroy-on-close
    )
        Mapa.mapa.mb-5(
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            idMapa='mapaModalEnviarGeometriaDiagnostico',
            height='200px',
            locked,
            v-if='showMap'
        )

        h3 {{ $t('mensagens.menuSig.infoRealizarDiagnostico') }}

        footer(slot='footer')
            el-button(size='mini', @click='fechar') {{ $t('mensagens.comuns.voltar') }}
            el-button(type='primary', size='mini', @click='prosseguir') {{ $t('mensagens.comuns.prosseguir') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import { mapActions } from 'vuex';
import { TipoAcaoGeometriaDesenhada } from '@/constants/TipoAcaoGeometriaDesenhada';

export default {
    name: 'ModalEnviarGeometriaDiagnostico',

    components: {
        Mapa
    },

    emits: ['fechar'],

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        geometria: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            layersMaps: [],
            mapConfig: {
                controls: {}
            },
            showMap: null
        };
    },

    watch: {
        geometria: function () {
            this.crarMapa();
        }
    },

    methods: {
        ...mapActions(['setGeometriaDesenhadaAcao', 'setAcaoEscolhida']),

        fechar() {
            this.$emit('fechar');
        },

        crarMapa() {
            this.layersMaps = [];

            if (this.geometria.type === 'Point') {
                this.showMap = false;
            } else {
                this.layersMaps.push({
                    geoJson: this.geometria,
                    style: getEstiloGeometria('area')
                });
                this.showMap = true;
            }
        },

        prosseguir() {
            this.setAcaoEscolhida({
                acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            });
            this.setGeometriaDesenhadaAcao(this.geometria);
            this.$router.push({ name: 'DiagnosticoSocioambiental' });
        }
    }
};
</script>

<style lang="scss" scoped>
.mapa {
    border-radius: 4px;
    overflow: hidden;
}

footer {
    display: flex;
    justify-content: space-between;

    margin-top: -20px;
}
</style>
